import { ProductionGrainCreationForm } from "../create/schema/production-grain-creation.schema";

export const hasEmptyProductionGrainFormValues = (
  values?: Partial<ProductionGrainCreationForm>,
) => {
  const nombre = String(values?.nombre ?? "").trim();
  const granoAdmis = String(values?.granoAdmis ?? "").trim();
  const aplicaPPMB = Array.isArray(values?.aplicaPPMB)
    ? values?.aplicaPPMB?.[0]
    : values?.aplicaPPMB;
  const sumaHA = Array.isArray(values?.sumaHA)
    ? values?.sumaHA?.[0]
    : values?.sumaHA;

  return (
    !nombre ||
    !granoAdmis ||
    typeof aplicaPPMB !== "boolean" ||
    typeof sumaHA !== "boolean"
  );
};
